var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 48,
    viewBox: "0 0 24 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6933 23.9999L16.6493 21.0441C17.1171 20.5763 17.1171 19.8181 16.6493 19.3506C16.1821 18.8831 15.4234 18.8831 14.9561 19.3506L12.0001 22.3069L9.04401 19.3506C8.57676 18.8831 7.81805 18.8831 7.3508 19.3506C6.88307 19.8183 6.88307 20.5766 7.3508 21.0441L10.3066 23.9999L7.3508 26.9557C6.88307 27.4234 6.88307 28.1817 7.3508 28.6491C7.5843 28.8831 7.89109 28.9998 8.1974 28.9998C8.50347 28.9998 8.8105 28.8831 9.04401 28.6491L12.0001 25.6933L14.9561 28.6494C15.1899 28.8834 15.4964 29 15.8027 29C16.109 29 16.4158 28.8834 16.6493 28.6494C17.1171 28.1817 17.1171 27.4234 16.6493 26.9559L13.6933 23.9999Z",
    fill: "#585757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.ed277d67.svg";
export { ForwardRef as ReactComponent };